import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { formatApiErrorDetail } from "@/lib/api";
import { Sparkles } from "lucide-react";

export default function DispatchRequestPage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({ customer_name: "", customer_email: "", customer_phone: "", zip_code: "", preferred_date: "", message: "" });
  const upd = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/dispatch", form);
      toast.success("Request received! A therapist will reach out shortly.");
      navigate("/");
    } catch (e2) {
      toast.error(formatApiErrorDetail(e2.response?.data?.detail) || "Failed to send");
    } finally { setLoading(false); }
  };

  const f = "mt-2 bg-[#F9F7F3] border-[#E8E2D6] rounded-xl h-12";
  return (
    <div className="max-w-2xl mx-auto px-6 py-16">
      <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#5F6C60] inline-flex items-center gap-2"><Sparkles className="w-3.5 h-3.5 text-[#0F766E]" /> Concierge request</div>
      <h1 className="font-serif-display text-4xl sm:text-5xl tracking-tighter mt-2">Need a therapist?</h1>
      <p className="text-[#5F6C60] mt-3 leading-relaxed">Tell us what you need. We'll match you with a vetted local therapist within 24 hours — no upfront fee.</p>

      <form onSubmit={submit} className="mt-10 bg-white p-8 rounded-2xl border border-[#E8E2D6] space-y-5">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
          <div><Label className="text-xs font-bold uppercase tracking-[0.15em]">Your name</Label><Input data-testid="dispatch-name" required value={form.customer_name} onChange={upd("customer_name")} className={f}/></div>
          <div><Label className="text-xs font-bold uppercase tracking-[0.15em]">Email</Label><Input data-testid="dispatch-email" type="email" required value={form.customer_email} onChange={upd("customer_email")} className={f}/></div>
          <div><Label className="text-xs font-bold uppercase tracking-[0.15em]">Phone</Label><Input data-testid="dispatch-phone" value={form.customer_phone} onChange={upd("customer_phone")} className={f}/></div>
          <div><Label className="text-xs font-bold uppercase tracking-[0.15em]">ZIP code</Label><Input data-testid="dispatch-zip" required value={form.zip_code} onChange={upd("zip_code")} className={f}/></div>
          <div className="sm:col-span-2"><Label className="text-xs font-bold uppercase tracking-[0.15em]">Preferred date (optional)</Label><Input data-testid="dispatch-date" type="date" value={form.preferred_date} onChange={upd("preferred_date")} className={f}/></div>
        </div>
        <div><Label className="text-xs font-bold uppercase tracking-[0.15em]">What do you need?</Label><Textarea data-testid="dispatch-message" required value={form.message} onChange={upd("message")} rows={5} className="mt-2 bg-[#F9F7F3] border-[#E8E2D6] rounded-xl" placeholder="Deep tissue, prenatal, in-home, hotel room…"/></div>
        <Button data-testid="dispatch-submit" disabled={loading} type="submit" className="w-full h-12 rounded-full bg-[#0F766E] hover:bg-[#0C5F58] text-white">{loading ? "Sending…" : "Find me a therapist"}</Button>
      </form>
    </div>
  );
}
